import { Select } from 'antd';
import { FormField } from './FormField';
import type { SelectProps } from 'antd';
import type { FormFieldProps } from './FormField';
import type { ControllerFieldState } from 'react-hook-form';

export type SelectFieldProps = FormFieldProps &
    SelectProps & {
        fieldState?: ControllerFieldState;
        name?: string;
    };

export const SelectField = ({
    fieldState,
    disabled = false,
    showValidationIcon,
    error,
    correct,
    ...props
}: SelectFieldProps) => {
    const errorMessage = error || fieldState?.error?.message;
    const isValid = correct || (fieldState?.isDirty && !fieldState?.error?.message);

    const getInputClassName = () => {
        if (errorMessage) {
            return 'incorrect';
        }

        if (isValid) {
            return 'correct';
        }

        return '';
    };

    return (
        <FormField
            {...props}
            fieldState={fieldState}
            labelFor={props?.id || props.name}
            error={error}
            correct={correct}
            showValidationIcon={showValidationIcon}>
            <Select
                allowClear
                showSearch={{
                    filterOption: (input, option) => {
                        const inputValue = input?.toLowerCase();
                        const optionValue =
                            typeof option?.label === 'string'
                                ? option?.label?.toString()?.toLowerCase()
                                : '';
                        return optionValue?.includes(inputValue) ?? false;
                    },
                }}
                {...props}
                id={props?.id || props.name}
                className={getInputClassName()}
                disabled={disabled}
            />
        </FormField>
    );
};
